export default class MapPositionController {
    /* @ngInject */
    constructor($rootScope, MapService) {
        this.$rootScope = $rootScope;
        this.MapService = MapService;

        this.$rootScope.$on('graphClicked', (event, data) => {
            this.showOnMap(data.latlng);
        });

        this.$rootScope.$on('chartDataPrepared', (event, data) => {
            this.MapService.clearMap();
            this.MapService.showCartTrace(data, 'mapDetailDivId');
        });
    }

    showOnMap(latlng) {
        const cart = { _source: { state: { latlng } } };
        this.MapService.showCartsOnMap([cart], 'mapDetailDivId', false, false);
    }

    $onChanges() {
        if (this.thing.shadow) {
            this.showOnMap(this.thing.shadow.state.reported.latlng);
            // this.MapService.clearMap();
        }
    }

    $onDestroy() {
        this.MapService.destroy();
    }
}



// WEBPACK FOOTER //
// ./src/app/detail/map-position/map-position.controller.js